import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { CheckCircleIcon } from 'lucide-react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <div className="text-center mb-12" data-id="element-217">
          <h2 className="text-4xl md:text-5xl font-black text-brand-dark mb-4" data-id="element-218">
            Empezá tu camino hoy
          </h2>
        </div>

        <div className="max-w-md mx-auto bg-white rounded-3xl p-8 md:p-10 shadow-2xl border-4 border-brand-primary relative flex flex-col items-center text-center z-10" data-id="element-219">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-primary text-white font-black px-8 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-220">
            ❄️ ACCESO COMPLETO
          </div>

          <h3 className="text-3xl font-black text-brand-dark mb-6 mt-4" data-id="element-221">
            PACK DE REFRIGERACIÓN
          </h3>

          <div className="mb-6" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/bLuQU16W7zusoDyUoMcC1z/ChatGPT_Image_25_mar_2026,_09_05_09_p.m..png" alt="Maestro de Refrigeración" className="w-full max-w-[200px] mx-auto" data-id="element-223" />
          </div>

          <div className="w-full h-px bg-gray-200 my-6" data-id="element-224"></div>

          <ul className="space-y-4 mb-8 text-left w-full" data-id="element-225">
            {['5 Módulos Maestros', 'Clases grabadas paso a paso', 'Kit de Presupuestación', 'Checklist del Técnico', 'Guía de Primer Taller', 'Manuales Automotor'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-226">
                <CheckCircleIcon className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-227" />
                <span className="text-gray-800 font-bold text-lg" data-id="element-228">{item}</span>
              </li>)}
          </ul>

          <div className="mt-auto text-center w-full" data-id="element-229">
            <div className="text-gray-400 text-2xl line-through font-bold mb-1" data-id="element-230">
              $49.900 ARS
            </div>
            <div className="text-6xl font-black text-brand-dark mb-8" data-id="element-231">
              $19.990 <span className="text-2xl text-gray-500" data-id="element-232">ARS</span>
            </div>
            <CTAButton text="🔥 → QUIERO EL PACK AHORA" isLink={true} className="text-xl py-5 w-full" data-id="element-233" />

            <div className="mt-8" data-id="element-234">
              <img src="https://cdn.magicpatterns.com/uploads/iNdd7dNPFTmkMXnAUq87Qt/jo3l6snt.png" alt="Garantía 7 Días de Reembolso" className="w-48 mx-auto" data-id="element-235" />
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 text-sm md:text-base text-gray-700 font-bold bg-white py-8 px-6 rounded-2xl shadow-sm border border-gray-200 mt-12 max-w-3xl mx-auto" data-id="element-236">
          <span className="flex items-center gap-2" data-id="element-237">
            <LockIcon className="w-6 h-6 text-brand-primary" data-id="element-238" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-239">
            <ZapIcon className="w-6 h-6 text-brand-amber" data-id="element-240" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-241">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-242" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2 md:mt-0 md:w-auto" data-id="element-243">
            <CreditCardIcon className="w-6 h-6 text-brand-steel" data-id="element-244" /> Mercado Pago
            | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}